export enum CalendarGroupCampaignType {
    BuyInPriceDiscount = 1,
    RetailSalesPriceDiscount = 2
}

(CalendarGroupCampaignType as any).__typeName = 'CalendarGroupCampaignType';